import { useComponents } from "@/hooks/useComponents.ts";
import { MouseEventHandler } from "react";

export interface OverlayProps {
  offset?: number;
  placement?: string;
}

export interface ToggleElementProps {
  toggle: () => void;
}

export interface DropdownMenuProps {
  toggleElement: (props: ToggleElementProps) => React.ReactElement;
  overlayProps?: OverlayProps;
  children?: React.ReactNode;
}

export const DropdownMenu = ({
  toggleElement,
  overlayProps,
  children,
}: DropdownMenuProps) => {
  const { DropdownMenu } = useComponents();

  return (
    <DropdownMenu toggleElement={toggleElement} overlayProps={overlayProps}>
      {children}
    </DropdownMenu>
  );
};

export interface DropdownMenuItemProps {
  text?: string;
  href?: string;
  icon?: React.ReactNode;
  onClick?: MouseEventHandler;
  disabled?: boolean;
  tooltip?: string;
  testId?: string;
  children?: React.ReactNode;
}

export const DropdownMenuItem = (props: DropdownMenuItemProps) => {
  const { DropdownMenuItem } = useComponents();

  return <DropdownMenuItem {...props} />;
};

export interface DropdownMenuBodyProps {
  children?: React.ReactNode;
}

export const DropdownMenuBody = (props: DropdownMenuBodyProps) => {
  const { DropdownMenuBody } = useComponents();

  return <DropdownMenuBody>{props.children}</DropdownMenuBody>;
};
